import { render, staticRenderFns } from "./AddPatrolRouter.vue?vue&type=template&id=8bbf7426"
import script from "./AddPatrolRouter.vue?vue&type=script&lang=js"
export * from "./AddPatrolRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports